// ============================================================
// PEBBLE — Utility menu (Policies / Privacy)
// ============================================================
// Small icon + dropdown replacing the footer's Policies/Cookie links.
// Rendered twice (desktop inline + mobile floating — see
// pebble-utility-menu.liquid), so this initializes every
// .pebble-utility-menu on the page independently rather than assuming
// a single instance.
// The [data-cookie-reopen] buttons inside are picked up independently
// by pebble-cookie-consent.js (it re-queries the whole document for
// that attribute), so this file only owns opening/closing its own
// panel — it also closes itself when one of those buttons is used, so
// the utility panel and the cookie card don't end up open together.

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pebble-utility-menu').forEach(function (root) {
      var toggle = root.querySelector('[data-utility-toggle]');
      if (!toggle) return;

      var openedAtY = 0;

      function setOpen(open) {
        root.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        if (open) openedAtY = window.scrollY;
      }

      toggle.addEventListener('click', function () {
        setOpen(!root.classList.contains('is-open'));
      });

      // The panel is anchored inside the sticky header, so left open it
      // would ride along and float over mid-page content — close it once
      // the visitor clearly scrolls on
      window.addEventListener(
        'scroll',
        function () {
          if (root.classList.contains('is-open') && Math.abs(window.scrollY - openedAtY) > 100) {
            setOpen(false);
          }
        },
        { passive: true }
      );

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-open')) {
          setOpen(false);
          toggle.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (root.classList.contains('is-open') && !root.contains(e.target)) {
          setOpen(false);
        }
      });

      // Keyboard parity with the outside-click close above: once focus
      // leaves the component (tabbing past the last link), the panel
      // shouldn't linger open behind the visitor
      root.addEventListener('focusout', function (e) {
        if (root.classList.contains('is-open') && !root.contains(e.relatedTarget)) {
          setOpen(false);
        }
      });

      root.querySelectorAll('[data-cookie-reopen]').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });
    });
  });
})();
